module.exports = __webpack_public_path__ + "static/item-2-9900a731aa92beb3604918ec1ad11526.jpeg";